import React, { useState } from 'react';

const CustomAmountCard = ({ onAddToCart }) => {
  const [amount, setAmount] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const numAmount = parseFloat(amount);
    if (numAmount > 0) {
      const customId = `custom-${Date.now()}`;
      onAddToCart({
        id: customId,
        cartItemId: `${customId}-${Math.random()}`,
        name: 'Custom Amount',
        description: 'Flexible contribution',
        price: numAmount,
        amount: numAmount,
        availableQuantity: 1, // Not tracked for custom amounts
      });
      setAmount('');
    }
  };

  return (
    <div className="bg-gradient-to-br from-primary to-primary-dark rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow p-6 text-white">
      <h3 className="text-xl font-semibold mb-2">Custom Amount</h3>
      <p className="mb-4 opacity-90">Couldn't find anything you like? You can contribute any amount for our adventure.</p>
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="custom-amount" className="block text-sm mb-2">
            Enter Amount (€)
          </label>
          <input
            id="custom-amount"
            type="number"
            min="1"
            step="0.01"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="50.00"
            className="w-full px-4 py-2 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-white"
          />
        </div>
        <button
          type="submit"
          className="w-full bg-white text-primary py-2 rounded-md hover:bg-gray-100 transition-colors font-semibold"
        >
          Add to Cart
        </button>
      </form>
    </div>
  );
};

export default CustomAmountCard;
